<template>
  <button
    class="flex items-center justify-between !no-underline cursor-pointer font-sans text-lg"
    :disabled="isHere"
    @click="click"
  >
    <SvgIcon name="user-light" aria-hidden="true" class="w-5 h-5" />
    <div class="ml-3">{{ $t("general.profile") }}</div>
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const isHere = computed(() => route.name === "profile" && !route.params.id);

const click = () => {
  router.push("/profile");
};
</script>
